
// class Slider {
//     constructor({ prev, next, slider, scrollAmount = 300, time = 1.2, auto = false, autoSpeed = 50 }) {
//         if (!prev || !next || !slider) {
//             console.error('Slider: missing required elements');
//             return;
//         }
//         this.next = next;
//         this.prev = prev;
//         this.slider = slider;
//         this.scrollAmount = scrollAmount;
//         this.time = time;
//         this.auto = auto;
//         this.autoSpeed = autoSpeed;
//         this.autoTween = null;
//         this.init();
//     }
//     init() {
//         this.bind();
//         if (this.auto) {
//             this.startAutoScroll();
//         }
//     }
//     bind() {
//         const isMobile = window.innerWidth < 768;
//         if (isMobile) {
//             this.slider.addEventListener('touchstart', () => this.pauseAuto());
//         } else {
//             this.slider.addEventListener('mouseenter', () => this.pauseAuto());
//             this.slider.addEventListener('mouseleave', () => this.resumeAuto());
//         }
//         this.prev.addEventListener('click', () => this.scrollLeft());
//         this.next.addEventListener('click', () => this.scrollRight());
//         window.addEventListener('resize', () => {
//             if (this.auto) this.startAutoScroll();
//         });
//     }
//     scrollLeft() {
//         this.pauseAuto();  
//         gsap.to(this.slider, {
//             scrollTo: { x: `-=${this.scrollAmount}` },
//             duration: this.time,
//             ease: "power4.out",
//             onComplete: () => {
//                 if (this.auto) this.startAutoScroll();
//             }
//         });
//     }
//     scrollRight() {
//         this.pauseAuto();  
//         gsap.to(this.slider, {
//             scrollTo: { x: `+=${this.scrollAmount}` },
//             duration: this.time,
//             ease: "power4.out",
//             onComplete: () => {
//                 if (this.auto) this.startAutoScroll();  
//             }
//         });
//     }
//     startAutoScroll() {
//         if (this.autoTween) this.autoTween.kill();
//         const current = this.slider.scrollLeft;
//         const max = this.slider.scrollWidth - this.slider.clientWidth;
//         const distance = max - current;
//         const duration = distance / this.autoSpeed;
//         this.autoTween = gsap.to(this.slider, {
//             scrollTo: { x: max }, 
//             duration: duration,
//             ease: "none",
//             onComplete: () => {
//                 gsap.to(this.slider, {
//                     scrollTo: { x: 0 }, 
//                     duration: this.time,
//                     onComplete: () => this.startAutoScroll() 
//                 });
//             }
//         });
//     }
    
//     pauseAuto() {
//         if (this.autoTween) this.autoTween.pause();
//     }
//     resumeAuto() {
//         if (this.auto && this.autoTween) this.autoTween.play();
//     }
// }

class Slider {
  constructor({ prev, next, slider, scrollAmount = 300, time = 1.2, auto = false, autoSpeed = 50 }) {
    if (!prev || !next || !slider) {
      console.error('Slider: missing required elements');
      return;
    }

    this.next = next;
    this.prev = prev;
    this.slider = slider;
    this.scrollAmount = scrollAmount;
    this.time = time;
    this.auto = auto;
    this.autoSpeed = autoSpeed;
    this.autoTween = null;
    this.mobileAutoUnlocked = false;

    this.init();
  }

  init() {
    this.bind();

    /*
      Desktop: auto-scroll can start immediately.
      Mobile: auto-scroll waits until user interaction.
    */
    if (this.auto && !this.isMobile()) {
      this.startAutoScroll();
    }
  }

  isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  bind() {
    if (this.isMobile()) {
      /*
        Mobile: first touch/click unlocks auto-scroll.
        This prevents Lighthouse mobile from starting auto animation during initial load.
      */
const unlockMobileAuto = () => {
  if (this.mobileAutoUnlocked) return;

  this.mobileAutoUnlocked = true;

  this.slider.removeEventListener('touchstart', unlockMobileAuto);
  this.slider.removeEventListener('pointerdown', unlockMobileAuto);

  if (this.auto) {
    setTimeout(() => {
      if (this.canAutoRun()) {
        this.startAutoScroll();
      }
    }, 2500);
  }
};

this.slider.addEventListener('touchstart', unlockMobileAuto, { passive: true });
this.slider.addEventListener('pointerdown', unlockMobileAuto, { passive: true });
    } else {
      this.slider.addEventListener('mouseenter', () => this.pauseAuto());
      this.slider.addEventListener('mouseleave', () => this.resumeAuto());
    }

    this.prev.addEventListener('click', () => {
      if (this.isMobile()) {
        this.mobileAutoUnlocked = true;
      }

      this.scrollLeft();
    });

    this.next.addEventListener('click', () => {
      if (this.isMobile()) {
        this.mobileAutoUnlocked = true;
      }

      this.scrollRight();
    });

    window.addEventListener('resize', () => {
      if (!this.auto) return;

      if (this.isMobile() && !this.mobileAutoUnlocked) {
        this.killAuto();
        return;
      }

      this.startAutoScroll();
    });
  }

  canAutoRun() {
    if (!this.auto) return false;

    /*
      On mobile, do not auto-run until user interacts.
    */
    if (this.isMobile() && !this.mobileAutoUnlocked) {
      return false;
    }

    return true;
  }

  scrollLeft() {
    this.pauseAuto();

    gsap.to(this.slider, {
      scrollTo: { x: `-=${this.scrollAmount}` },
      duration: this.time,
      ease: "power4.out",
      onComplete: () => {
        if (this.canAutoRun()) this.startAutoScroll();
      }
    });
  }

  scrollRight() {
    this.pauseAuto();

    gsap.to(this.slider, {
      scrollTo: { x: `+=${this.scrollAmount}` },
      duration: this.time,
      ease: "power4.out",
      onComplete: () => {
        if (this.canAutoRun()) this.startAutoScroll();
      }
    });
  }

  startAutoScroll() {
    if (!this.canAutoRun()) return;

    this.killAuto();

    const current = this.slider.scrollLeft;
    const max = this.slider.scrollWidth - this.slider.clientWidth;

    if (max <= 0) return;

    const distance = max - current;
    const duration = Math.max(6, distance / this.autoSpeed);

    this.autoTween = gsap.to(this.slider, {
      scrollTo: { x: max },
      duration: duration,
      ease: "none",
      onComplete: () => {
        if (!this.canAutoRun()) return;

        gsap.to(this.slider, {
          scrollTo: { x: 0 },
          duration: this.time,
          onComplete: () => {
            if (this.canAutoRun()) this.startAutoScroll();
          }
        });
      }
    });
  }

  pauseAuto() {
    if (this.autoTween) {
      this.autoTween.pause();
    }
  }

  resumeAuto() {
    if (this.canAutoRun() && this.autoTween) {
      this.autoTween.play();
    }
  }

  killAuto() {
    if (this.autoTween) {
      this.autoTween.kill();
      this.autoTween = null;
    }

    gsap.killTweensOf(this.slider);
  }
}